<template>
  <div class="plk_documentation" v-html="readme"></div>
</template>

<script>
import Vue from 'vue'
import { TYPE_INTERNAL_OBJECT, TYPE_EXTERNAL_OBJECT } from '@/services/component'
import i18n from './i18n'
export default {
  name: 'documentation',
  props: {
    initValue: {
      type: Object,
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      readme: ''
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
      this.loadReadme()
    },
    async loadReadme () {
      if (this.type) {
        const loadedComponent = await this.$servicesPLK.component.loadComponent(this.type)
        if (loadedComponent.type === TYPE_INTERNAL_OBJECT) {
          Vue.set(this, 'readme', loadedComponent.component.options.methods.getReadme())
        } else if (loadedComponent.type === TYPE_EXTERNAL_OBJECT) {
          Vue.set(this, 'readme', loadedComponent.component.methods.getReadme())
        }
      }
    }
  },
  watch: {
    type () {
      this.loadReadme()
    }
  }
}
</script>

<style scoped lang="scss">
.u-full-width {
  resize: vertical;
  min-height: 50vh;
}
</style>
